import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center md:justify-end bg-white border-b border-gray-200 flex py-4 pl-8" }
const _hoisted_2 = { class: "flex flex-row mr-auto" }
const _hoisted_3 = { class: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8" }
const _hoisted_4 = { class: "py-6" }
const _hoisted_5 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_6 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }

import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { inject, onMounted, ref, watch } from "vue";
import Navbar from "@/components/tools/Navbar.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import DateSelector from "@/components/tools/DateSelector.vue";
import UserActivityFilterDialog from "@/components/dialogs/UserActivityFilterDialog.vue";
import router from "@/router";
import { translate } from "@/utils/tools";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserActivityLogs',
  setup(__props) {

dayjs.extend(localizedFormat);
const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const dataRows = ref([]);
const isLoaded = ref(false);
const advanceFilterModal = ref(false);
const columns = [
  {
    label: translate("messages.userActivityLog.username"),
    field: "username",
    class: () => "cursor-pointer hover:underline",
    isFunction: true,
    function: (data: any) =>
      data.userId ? router.push(`/players/${data.userId}`) : null,
  },
  {
    label: translate("messages.userActivityLog.action"),
    field: "action",
    align: "left",
  },
  {
    label: translate("messages.userActivityLog.updatedField"),
    field: "updatedField",
    align: "left",
  },
  {
    label: translate("messages.userActivityLog.originalValue"),
    field: "originalValue",
    align: "left",
  },
  {
    label: translate("messages.userActivityLog.updatedValue"),
    field: "updatedValue",
    align: "left",
    class: (data: any) => "flex-wrap break-all",
  },
  {
    label: translate("messages.userActivityLog.notes"),
    field: "notes",
    align: "left",
    class: (data: any) => "flex-wrap break-all",
  },
  {
    label: translate("messages.userActivityLog.updatedBy"),
    field: "actorUsername",
    align: "left",
  },
  {
    label: translate("messages.userActivityLog.approvedBy"),
    field: "approvedByUsername",
    align: "left",
  },
  {
    label: translate("messages.userActivityLog.status"),
    field: "status",
    align: "center",
    class: (data: any) => {
      let baseClass = `inline-block px-1 py-1 rounded-lg text-white text-xs font-bold`;
      if (data.status == "APPROVED") baseClass += ` bg-green-600`;
      else if (data.status == "REJECTED") baseClass += ` bg-red-600`;
      else if (data.status == "PENDING") baseClass += ` bg-yellow-600`;
      else baseClass = "text-xs font-bold";

      return baseClass;
    },
  },
  {
    label: translate("messages.userActivityLog.updatedDate"),
    field: "createdAt",
    align: "left",
    format: (data: any) => dayjs(data.updatedAt).locale("th").format("LLL"),
  },
];
const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
});
const filterForm = ref({
  userId: null,
  username: null,
  action: null,
  updatedField: null,
  originalValue: null,
  updatedValue: null,
  from: null,
  to: null,
  status: null,
});

const filterModal = (flag = 0) => {
  advanceFilterModal.value = !advanceFilterModal.value;
  if (flag == 1) {
    pageConfig.value.page = 1;
    fetchPageData();
  }
};
const fetchPageData = async () => {
  isLoaded.value = false;
  const { page, rowsPerPage } = pageConfig.value;
  const {
    username,
    userId,
    action,
    updatedField,
    originalValue,
    updatedValue,
    from,
    to,
    status,
  } = filterForm.value;
  const payload = {
    operatorId: store.state.selectedOperator.operatorId,
    page: page - 1,
    limit: rowsPerPage,
    offset: page * rowsPerPage - rowsPerPage,
    sortBy: [["createdAt", -1]],
    username: username || null,
    userId: userId || null,
    action: action || null,
    updatedField: updatedField || null,
    originalValue: originalValue || null,
    updatedValue: updatedValue || null,
    from: from || null,
    to: to || null,
    status: status ? [status] : null,
  };
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/user-activity-logs/list`;
  const [data, count] = await axios
    .post(url, payload)
    .then(({ data }) => data.result);

  // if(!data || data.length == 0){
  //   if(pageConfig.value.page == 1){
  //     dataRows.value = []
  //     isLoaded.value = true;
  //     return
  //   }
  //   pageConfig.value.page = page - 1
  //   return
  // }
  pageConfig.value.dataLength = data.length;

  dataRows.value = data;
  pageConfig.value = {
    ...pageConfig.value,
    count,
    pageCount: Math.ceil(count / rowsPerPage),
  };
  /** update url to persist page config */
  window.history.replaceState(
    {},
    document.title,
    `user-activity-logs?${stringify({ page, rowsPerPage })}`
  );
  isLoaded.value = true;
};
const onSearch = (payload: { from: null; to: null }) => {
  filterForm.value.from = payload.from;
  filterForm.value.to = payload.to;
  fetchPageData();
};

onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});
/** fetch data when current page was changed */
watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = 1;
    fetchPageData();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(Navbar, {
        title: _ctx.$t('messages.userActivityLog.userActivityLogs')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(DateSelector, { onSearch: onSearch })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (filterModal())),
            class: "ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
          }, [
            _createVNode(_component_font_awesome_icon, {
              class: "text-white mr-2",
              icon: ['far', 'filter'],
              transform: ""
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.userActivityLog.advanceFilter")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(DataTable, {
              columns: columns,
              data: dataRows.value,
              isLoaded: isLoaded.value
            }, null, 8, ["data", "isLoaded"]),
            _createVNode(Pagination, {
              config: pageConfig.value,
              "onUpdate:config": _cache[1] || (_cache[1] = ($event: any) => ((pageConfig).value = $event))
            }, null, 8, ["config"])
          ])
        ])
      ])
    ]),
    _createVNode(UserActivityFilterDialog, {
      show: advanceFilterModal.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((advanceFilterModal).value = $event)),
      form: filterForm.value,
      "onUpdate:form": _cache[3] || (_cache[3] = ($event: any) => ((filterForm).value = $event)),
      onSubmit: filterModal
    }, null, 8, ["show", "form"])
  ], 64))
}
}

})